module.exports = __webpack_public_path__ + "img/home-kv.e01cace7.png";